var map = {
	"./Stroke 1.png": 986,
	"./Why Our Save the Dat.png": 987,
	"./all_about_shipping@2x.png": 988,
	"./ask_for_everything@2x.png": 989,
	"./big-day@1x.png": 510,
	"./big-day@2x.png": 511,
	"./birds@1x.png": 990,
	"./birds@2x.png": 991,
	"./check-list@1x.png": 532,
	"./check-list@2x.png": 533,
	"./circle-better@1x.png": 992,
	"./circle-better@2x.png": 993,
	"./empty_rsvp.png": 994,
	"./empty_rsvp2x.png": 995,
	"./envelope.png": 534,
	"./envelope.svg": 996,
	"./envelope@2x.png": 997,
	"./events_doodle.png": 229,
	"./events_doodle.svg": 998,
	"./gifts@1x.png": 999,
	"./gifts@2x.png": 1000,
	"./guest-list@1x.png": 494,
	"./guest-list@2x.png": 495,
	"./guest.png": 1001,
	"./guest.svg": 1002,
	"./guest2x.png": 1003,
	"./guest_approved@2x.png": 1004,
	"./invitations@1x.png": 512,
	"./invitations@2x.png": 513,
	"./invites_paper.svg": 1005,
	"./invites_paper@1x.png": 535,
	"./invites_paper@2x.png": 536,
	"./laptop-one-heart.png": 1006,
	"./laptop-one-heart@2x.png": 1007,
	"./laptop@1x.png": 1008,
	"./laptop@2x.png": 1009,
	"./long-page-checklist.png": 1010,
	"./long-page-checklist@2x.png": 1011,
	"./make_it_personal@2x.png": 1012,
	"./namecard-with-name.png": 1013,
	"./namecard-with-name@2x.png": 1014,
	"./namecard_no_name.svg": 420,
	"./namecard_with_name.svg": 1015,
	"./namecard_with_question_marks.svg": 105,
	"./no_address.png": 1016,
	"./no_address2x.png": 1017,
	"./onboarding_1.png": 421,
	"./onboarding_1@2x.png": 422,
	"./onboarding_2.png": 1018,
	"./onboarding_2@2x.png": 1019,
	"./onboarding_3.png": 423,
	"./onboarding_3@2x.png": 424,
	"./onboarding_4.png": 1020,
	"./onboarding_4@2x.png": 1021,
	"./red-star-left@1x.png": 496,
	"./red-star-left@2x.png": 497,
	"./red-star-right@1x.png": 498,
	"./red-star-right@2x.png": 499,
	"./registry_publish_champagne.svg": 1022,
	"./rsvp@1x.png": 514,
	"./rsvp@2x.png": 515,
	"./save-the-date@1x.png": 516,
	"./save-the-date@2x.png": 517,
	"./ta-da.png": 1023,
	"./ta-da@2x.png": 1024,
	"./talk.svg": 1025,
	"./talk@1x.png": 488,
	"./talk@2x.png": 489,
	"./timeline-line-dark@1x.png": 518,
	"./timeline-line-dark@2x.png": 519,
	"./timeline-line@1x.png": 1026,
	"./timeline-line@2x.png": 1027,
	"./tips.svg": 1028,
	"./underline_long@1x.png": 466,
	"./underline_long@2x.png": 467,
	"./underline_sm@1x.png": 482,
	"./underline_sm@2x.png": 483,
	"./website_publish_confetti.svg": 425,
	"./wedding-websites@1x.png": 537,
	"./wedding-websites@2x.png": 538,
	"./wedding_help.png": 539,
	"./wedding_help.svg": 1029,
	"./wedding_help@2x.png": 1030
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 228;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 228
// module chunks = 40